import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id EA110B23-B08F-4DAE-8F23-37A298B89A74
 * name ellipse-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ellipse-outline.svg
 * tags
 * - Shape 
 */
export const EllipseOutlineIcon = createSvgIcon(<><path d="M12,6C16.41,6 20,8.69 20,12C20,15.31 16.41,18 12,18C7.59,18 4,15.31 4,12C4,8.69 7.59,6 12,6M12,4C6.5,4 2,7.58 2,12C2,16.42 6.5,20 12,20C17.5,20 22,16.42 22,12C22,7.58 17.5,4 12,4Z" /></>, 'EllipseOutlineIcon');
export default EllipseOutlineIcon